/*
<summary>
   This file is used to provide initial values or state to the Process Module Observables.
   Developer:Urvashi, Created Date: 21-November-2024
</summary>
*/
import { IGetDimension } from '../../models/forms/IAddDimension';
import { IDimensionListVM } from '../../models/response/IDimensionResponse';

const initialDimensionState: IDimensionListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  DimensionItems: [],
};

export default initialDimensionState;